"use client";

import React, { forwardRef } from "react";
import styled from "styled-components";
import { Clear } from "@churchofjesuschrist/eden-icons";
import { tagStyles, Content } from "./sharedStyles";
import { spacing4, spacing8 } from "@churchofjesuschrist/eden-style-constants";
import { A11y } from "@churchofjesuschrist/eden-buttons";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ClearIcon = styled(Clear).withConfig({
  componentId: "sc-1pdl6br-0"
})(["", ":not(:empty) + &&{margin-inline-start:", ";}"], Content, spacing4);
export const InternalUseOnlyDismissible = styled(A11y).withConfig({
  componentId: "sc-1pdl6br-1"
})(["", " padding-inline-end:", ";"], tagStyles, spacing8);

/**
 * A tag is a keyword or term that is assigned to a piece of information. The `Dismissible` tag will display an `X` and trigger an event when clicked.
 * @param {object} props - The component props
 * @param {React.ReactNode} props.children - The tag contents. These will not be displayed when used inside a `<Combo>` element, but are required for accessibility purposes.
 * @param {boolean} [props.disabled] - Whether the tag is disabled
 * @param {Function} [props.onClick] - Handler for when the tag is clicked
 * @param {string} [props.href] - The link URL. (Also changes the tag from a `<button>` to an `<a>`)
 * @param {React.Ref} ref - Ref forwarded to the underlying element.
 * @returns {React.ReactElement} The `Dismissible` component
 */
const DismissibleComponent = ({
  children,
  disabled,
  onClick = () => {},
  href,
  ...props
} = {}, ref) => {
  return /*#__PURE__*/_jsxs(InternalUseOnlyDismissible, {
    ...(href && !disabled ? {
      as: "a"
    } : {}),
    disabled,
    onClick,
    href,
    ...props,
    ref: ref,
    children: [/*#__PURE__*/_jsx(Content, {
      children: children
    }), /*#__PURE__*/_jsx(ClearIcon, {
      size: "1rem"
    })]
  });
};
const Dismissible = /*#__PURE__*/forwardRef(DismissibleComponent);
Dismissible.displayName = "Dismissible";
export default Dismissible;